import type { Platform } from '@sparklayer-io/spark-dash-core/context/env-context';
import { Input, LearnMoreLink, Text } from '@ui/themed';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import { PLATFORM_I18N, type StoreIdFieldConfig } from '../constants';
import { UrlExample } from './url-example';

const STORE_ID_I18N = 'features:platform.components.store_id' satisfies I18nPrefix;

export function StoreIdField({
  platform,
  config,
  value,
  onChange,
  disabled,
  error,
}: {
  platform: Platform;
  config: StoreIdFieldConfig;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
}) {
  const platformName = t(PLATFORM_I18N.platformName(platform));

  return (
    <div className="space-y-3">
      <Input
        name="platform_store_id"
        label={t(config.labelKey)}
        prefix={config.prefix}
        placeholder={config.placeholder}
        pattern={config.pattern}
        title={config.patternTitle}
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={error}
        autoComplete="new-password"
      />
      <Text>
        {t(`${STORE_ID_I18N}.helper_find`, { platform: platformName })}
        {config.example && (
          <>
            <br />
            <Trans
              ns="features"
              i18nKey={config.example.messageKey}
              components={{
                url: (
                  <UrlExample
                    template={config.example.template}
                    highlight={config.example.highlight}
                  />
                ),
                id: (
                  <UrlExample
                    template={config.example.highlight}
                    highlight={config.example.highlight}
                  />
                ),
              }}
            />
          </>
        )}
        {config.redirectsForAuth && (
          <>
            <br />
            {t(`${STORE_ID_I18N}.helper_redirect`, { platform: platformName })}
          </>
        )}
        {config.helperKey && (
          <>
            <br />
            {t(config.helperKey)}
          </>
        )}
        {config.learnMoreUrl && (
          <>
            {' '}
            <LearnMoreLink link={config.learnMoreUrl} />
          </>
        )}
      </Text>
    </div>
  );
}
